import 'react-dates/initialize';
import React from 'react';  
import { connect } from 'react-redux'
//import { Container } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import $ from 'jquery'
import moment from 'moment';  
import { ACT_SELECTPERIOD } from './actions.js';
import './css/Report.css';
import TooltipButton from './TooltipButton.jsx'
import { REP_TYPES} from './reporttypes'


class QuickPeriodSelector extends React.Component {  

	
	componentDidMount() {
		
		//$('input[name="dates"]').click();
		$('.ButtonColumn').addClass("align-self-center").css("padding","0px").css("textAlign","center");
		$('.ButtonRow').addClass("m-1").css({padding: "0px"});
		//$('.periodSelector').css("width","100%");
		//$('.generateButton').css("width","100%");
			
	}

	componentDidUpdate() {

		//$('input[name="dates"]').click();
		$('.ButtonColumn').addClass("align-self-center").css("padding", "0px").css("textAlign", "center");
		$('.ButtonRow').addClass("m-1").css({ padding: "0px" });
		//$('.periodSelector').css("width","100%");
		//$('.generateButton').css("width","100%");

	}
		
	
	getWeekStart(){
		return moment().startOf("week").add(1,'d')
		
	}
	
	selectThisWeek() {
		var start = this.getWeekStart();
		var	end = moment(start);
		end.add(6,'d');
		
		this.props.setPeriod(start,end)
		
	}
	selectPrevWeek() {
		var start = this.getWeekStart();
		start.add(-1,'W');
		var	end = moment(start);
		end.add(6,'d');
		
		this.props.setPeriod(start, end)
		
	}
	
	
	selectThisMonth() {
		var start = moment().startOf("month")
		var	end = moment(start);
		end.endOf("month");
		
		this.props.setPeriod(start, end)
		
	}
	selectPrevMonth() {
		var start = moment().startOf("month")
		start.add(-1,'M');
		var	end = moment(start);
		end.endOf("month");
		
		this.props.setPeriod(start, end)
		
	}
	
	selectThisYear() {
		var start = moment().startOf("year")
		var	end = moment(start);
		end.endOf("year");
		
		this.props.setPeriod(start, end)
		
	}
	
	selectPrevYear() {
		var start = moment().startOf("year")
		start.add(-1,"Y");
		var	end = moment(start);
		end.endOf("year");
		
		this.props.setPeriod(start, end)
		
	}
	
	
	
    
	render() {  
		
				
		return (  
			< >
				<div className="reportbuttons ">
					<Row >
						<Col className="ButtonColumn">
							<TooltipButton className="periodSelector mx-auto" variant="outline-light" tooltiptext="Previous Week" onClick={() => this.selectPrevWeek()} content={<Image alt="Previous Week" src="prev_week.png" style={{ width: "32px" }} />}/>
						</Col>
						<Col className="ButtonColumn">
							<TooltipButton className="periodSelector mx-auto" variant="outline-light" tooltiptext="This Week" onClick={() => this.selectThisWeek()} content={<Image alt="This Week" src="week.png" style={{ width: "32px" }} />} />
						</Col>                                                          
						<Col className="ButtonColumn">    
							<TooltipButton className="periodSelector mx-auto" variant="outline-light" tooltiptext="Previous Month" onClick={() => this.selectPrevMonth()} content={<Image alt="Previous Month" src="prev_month.png" style={{ width: "32px" }} />}/>
						</Col>
						<Col className="ButtonColumn">
							<TooltipButton className="periodSelector mx-auto" variant="outline-light" tooltiptext="This Month" onClick={() => this.selectThisMonth()} content={<Image alt="This Month" src="month.png" style={{ width: "32px" }} />} />
						</Col>                                                          
						{
							this.props.showYearSelector &&
							<Col className="ButtonColumn">
								<TooltipButton className="periodSelector mx-auto" variant="outline-light" tooltiptext="Previous Year" onClick={() => this.selectPrevYear()} content={<Image alt="Previous Year" src="prev_year.png" style={{ width: "32px" }} />} />
							</Col>
						}
						{
							this.props.showYearSelector &&
							<Col className="ButtonColumn">
								<TooltipButton className="periodSelector mx-auto" variant="outline-light" tooltiptext="This Year" onClick={() => this.selectThisYear()} content={<Image alt="This Year" src="year.png" style={{ width: "32px" }} />} />
							</Col>                                                          
							
						}
					</Row>		
				</div>
			</>
        );  
    }  
}  

function mapDispatchToProps(dispatch) {
	return {
		setPeriod: (startDate, endDate) => { dispatch({ type: ACT_SELECTPERIOD, startDate, endDate }) }
	}

}

function mapStateToProps(state) {
	let resLst = $.grep(Object.keys(REP_TYPES), (menu) => (REP_TYPES[menu] === state.menu.menu) )
	return { showYearSelector: (resLst.length===1)}
}
  
export default connect(mapStateToProps, mapDispatchToProps)(QuickPeriodSelector);  